const buildOcrQueueJobPayload = ({
  tripAir,
  tripSea,
  passport,
  purchase_cards,
  purchase_requests,
  customer
}) => {
  const documents = []
  const classificationCategories = {
    passports: [],
    credit_cards: [],
    cruise_ids: [],
    boarding_passes: [],
    pos_receipts: [],
    credit_card_slips: []
  }
  const purchaseRequestGroups = []

  const activeTripType =
    tripAir?.attributes?.air_sea_type || tripSea?.air_sea_type

  // Helper function to extract file data
  const extractFileData = file => {
    const fileObj = file?.file_obj || file
    const documentId = fileObj?.id || file?.id
    const documentRevisionId =
      fileObj?.document_revision_id || file?.document_revision_id
    const filename = fileObj?.name || file?.name || file?.fileName || ''

    if (documentId && documentRevisionId) {
      return {
        document_id: documentId,
        filename: filename,
        document_revision_id: documentRevisionId
      }
    }
    return null
  }

  // Add passport documents
  if (passport?.id && passport?.files?.length > 0) {
    passport.files.forEach((file, index) => {
      const fileData = extractFileData(file)
      if (fileData) {
        documents.push(fileData)
        classificationCategories.passports.push({
          filename: fileData.filename,
          confidence: 0.95,
          passport_id: index + 1
        })
      }
    })
  }

  // Add cruise_id documents (from trip)
  const activeTrip = activeTripType === 'air' ? tripAir : tripSea
  const tripId =
    activeTripType === 'air' ? tripAir?.attributes?.id : tripSea?.id

  if (tripId && activeTrip?.files?.cruise?.length > 0) {
    activeTrip.files.cruise.forEach((file, index) => {
      const fileData = extractFileData(file)
      if (fileData) {
        documents.push(fileData)
        classificationCategories.cruise_ids.push({
          filename: fileData.filename,
          confidence: 0.88,
          cruise_id: index + 1
        })
      }
    })
  }

  // Add boarding_pass documents (from trip air)
  if (
    activeTripType === 'air' &&
    tripId &&
    tripAir?.files?.boarding_pass?.length > 0
  ) {
    tripAir.files.boarding_pass.forEach((file, index) => {
      const fileData = extractFileData(file)
      if (fileData) {
        documents.push(fileData)
        classificationCategories.boarding_passes.push({
          filename: fileData.filename,
          confidence: 0.92,
          boarding_pass_id: index + 1
        })
      }
    })
  }

  // Add credit card documents
  if (purchase_cards?.length > 0) {
    purchase_cards.forEach((card, cardIndex) => {
      if (card?.attributes?.id && card?.files?.length > 0) {
        card.files.forEach((file, fileIndex) => {
          const fileData = extractFileData(file)
          if (fileData) {
            documents.push(fileData)
            classificationCategories.credit_cards.push({
              filename: fileData.filename,
              confidence: 0.9,
              card_id: cardIndex + 1,
              front: '',
              back: fileData.filename
            })
          }
        })
      }
    })
  }

  // Add purchase receipt documents (POS and CC slips)
  if (purchase_requests?.length > 0) {
    purchase_requests.forEach((pr, prIndex) => {
      const groupFiles = {
        pos_receipts: [],
        credit_card_slips: []
      }

      // Add POS receipts
      if (pr?.files?.pos_receipt?.length > 0 && pr?.attributes?.id) {
        pr.files.pos_receipt.forEach((file, index) => {
          const fileData = extractFileData(file)
          if (fileData) {
            documents.push(fileData)
            classificationCategories.pos_receipts.push({
              filename: fileData.filename,
              confidence: 0.89,
              pos_id: classificationCategories.pos_receipts.length + 1
            })
            groupFiles.pos_receipts.push({
              filename: fileData.filename
            })
          }
        })
      }

      // Add credit card receipt slips from payment methods
      if (pr?.payment_methods?.length > 0) {
        pr.payment_methods.forEach(paymentMethod => {
          if (
            paymentMethod?.files?.slip?.length > 0 &&
            paymentMethod?.attributes?.id
          ) {
            paymentMethod.files.slip.forEach(file => {
              const fileData = extractFileData(file)
              if (fileData) {
                documents.push(fileData)
                classificationCategories.credit_card_slips.push({
                  filename: fileData.filename,
                  confidence: 0.86,
                  slip_id: classificationCategories.credit_card_slips.length + 1
                })
                groupFiles.credit_card_slips.push({
                  filename: fileData.filename
                })
              }
            })
          }
        })
      }

      // Add group if it has any files
      if (
        groupFiles.pos_receipts.length > 0 ||
        groupFiles.credit_card_slips.length > 0
      ) {
        purchaseRequestGroups.push(groupFiles)
      }
    })
  }

  // Build classification_result categories array
  const categories = Object.entries(classificationCategories)
    .filter(([_, files]) => files.length > 0)
    .map(([type, files]) => ({
      type: type,
      files: files
    }))

  return {
    contact_id: customer.id,
    documents: documents,
    classification_result: {
      categories: categories,
      groups: purchaseRequestGroups
    }
  }
}

export default buildOcrQueueJobPayload
